// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"H6-z"};